import {DlMuiButton, GetStylesFunction} from '@wallaby-ui/core';
import {FC, MouseEvent, TouchEvent} from 'react';
import {css, useTheme} from '@mui/material';

interface Props {
  onDatePickerClose: (e: MouseEvent | TouchEvent) => void;
}

export const FilterNodeRangeApplyButton: FC<Props> = (props: Props) => {
  const {onDatePickerClose} = props;

  const theme = useTheme();
  const muiStyles = getStyles({theme});

  return (
    <DlMuiButton
      type='chip-filled'
      data-name={'dl-mui-date-picker-action-bar--apply'}
      css={muiStyles.button}
      title={'filter.apply'}
      onClick={onDatePickerClose}
    />
  );
};

const getStyles: GetStylesFunction = () => ({
  button: css`
    background-color: var(--dlTheme-500) !important;
    color: white !important;

    &:active,
    &:hover {
      background-color: var(--dlTheme-600) !important;
      color: white !important;
    }
  `,
});
